import api from '../../../lib/api';
import type {
  PaginatedSafetyIncidents,
  SafetyIncidentPayload,
  SafetyIncidentSummary,
  SafetyIndicesResult,
  SafetyPeriodHoursRow,
} from './types';

export interface ListSafetyIncidentsParams {
  page?: number;
  pageSize?: number;
  type?: string;
  severity?: string;
  status?: string;
  from?: string;
  to?: string;
  search?: string;
}

export const fetchSafetyIncidents = async (
  params: ListSafetyIncidentsParams = {},
): Promise<PaginatedSafetyIncidents> => {
  const { data } = await api.get<PaginatedSafetyIncidents>('safety-incidents', { params });
  return data;
};

export const fetchSafetyIncident = async (id: string): Promise<SafetyIncidentSummary> => {
  const { data } = await api.get<SafetyIncidentSummary>(`safety-incidents/${id}`);
  return data;
};

export const createSafetyIncident = async (payload: SafetyIncidentPayload) => {
  const { data } = await api.post('safety-incidents', payload);
  return data;
};

export const updateSafetyIncident = async (id: string, payload: Partial<SafetyIncidentPayload>) => {
  const { data } = await api.put(`safety-incidents/${id}`, payload);
  return data;
};

export const transitionSafetyIncidentStatus = async (
  id: string,
  status: SafetyIncidentSummary['status'],
) => {
  const { data } = await api.patch(`safety-incidents/${id}/status`, { status });
  return data;
};

export const escalateSafetyIncident = async (
  id: string,
  payload?: { title?: string; description?: string },
) => {
  const { data } = await api.post(`safety-incidents/${id}/escalate`, payload ?? {});
  return data as { incidentId: string; qmsRecordId: string };
};

export const fetchSafetyIndices = async (params: {
  from: string;
  to: string;
  hoursWorked?: number;
}): Promise<SafetyIndicesResult> => {
  const { data } = await api.get<SafetyIndicesResult>('safety-incidents/indices', { params });
  return data;
};

export const fetchSafetyPeriodHours = async (): Promise<SafetyPeriodHoursRow[]> => {
  const { data } = await api.get<{ data: SafetyPeriodHoursRow[] }>('safety-incidents/period-hours');
  return data.data;
};

export const upsertSafetyPeriodHours = async (payload: {
  periodStart: string;
  periodEnd: string;
  hoursWorked: number;
}) => {
  const { data } = await api.put('safety-incidents/period-hours', payload);
  return data;
};
